<template>
  <TableLayout :permissions="['business:memberrevenue:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="主键" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="searchForm.deleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="searchForm.createUser" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="searchForm.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="searchForm.updateUser" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="searchForm.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="会员主键" prop="memberId">
        <el-input v-model="searchForm.memberId" placeholder="请输入会员主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="变动类型:0=用工单收入；1=货运单收入；2=供餐单收入；3=提现申请；" prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入变动类型:0=用工单收入；1=货运单收入；2=供餐单收入；3=提现申请；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="收支类型:1=收入；-1=支出；" prop="optType">
        <el-input v-model="searchForm.optType" placeholder="请输入收支类型:1=收入；-1=支出；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="变动金额" prop="amount">
        <el-input v-model="searchForm.amount" placeholder="请输入变动金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="变动前金额" prop="beforeAmount">
        <el-input v-model="searchForm.beforeAmount" placeholder="请输入变动前金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="变动后金额" prop="afterAmount">
        <el-input v-model="searchForm.afterAmount" placeholder="请输入变动后金额" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="业务记录主键" prop="objId">
        <el-input v-model="searchForm.objId" placeholder="请输入业务记录主键" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="业务类型:0=订单业务；1=提现业务；" prop="objType">
        <el-input v-model="searchForm.objType" placeholder="请输入业务类型:0=订单业务；1=提现业务；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="业务状态:0=成功；1=失败；2=处理中；" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入业务状态:0=成功；1=失败；2=处理中；" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:memberrevenue:create', 'business:memberrevenue:delete']">
        <li><el-button type="primary" @click="$refs.operaMemberRevenueWindow.open('新建会员收支记录')" icon="el-icon-plus" v-permissions="['business:memberrevenue:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:memberrevenue:delete']">删除</el-button></li>
      </ul>
      <el-table
          :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="deleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="createUser" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="updateUser" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="会员主键" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="变动类型:0=用工单收入；1=货运单收入；2=供餐单收入；3=提现申请；" min-width="100px"></el-table-column>
        <el-table-column prop="optType" label="收支类型:1=收入；-1=支出；" min-width="100px"></el-table-column>
        <el-table-column prop="amount" label="变动金额" min-width="100px"></el-table-column>
        <el-table-column prop="beforeAmount" label="变动前金额" min-width="100px"></el-table-column>
        <el-table-column prop="afterAmount" label="变动后金额" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="业务记录主键" min-width="100px"></el-table-column>
        <el-table-column prop="objType" label="业务类型:0=订单业务；1=提现业务；" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="业务状态:0=成功；1=失败；2=处理中；" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:memberrevenue:update', 'business:memberrevenue:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaMemberRevenueWindow.open('编辑会员收支记录', row)" icon="el-icon-edit" v-permissions="['business:memberrevenue:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:memberrevenue:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaMemberRevenueWindow ref="operaMemberRevenueWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaMemberRevenueWindow from '@/components/business/OperaMemberRevenueWindow'
export default {
  name: 'MemberRevenue',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaMemberRevenueWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        memberId: '',
        type: '',
        optType: '',
        amount: '',
        beforeAmount: '',
        afterAmount: '',
        objId: '',
        objType: '',
        status: ''
      }
    }
  },
  created () {
    this.config({
      module: '会员收支记录',
      api: '/business/memberRevenue',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
